module.exports = __webpack_public_path__ + "static/img/act-trader-logo.91de9f7.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/act-trader-logo.svg
// module id = H8dO
// module chunks = 4